import Enum from '../../utils/enum'

const MessageType = new Enum([
  'ESCALATION_EXECUTION_CHANGE',
  'GROUP_MEMBERSHIP_CHANGE',
  'HIGHER_CONTINUATION',
  'LOWER_CONTINUATION',
  'USER_SENT',
])

export default MessageType
